/*
  Elite Sleep cart helper. Loaded once (defer) from layout/theme.liquid.
  Adds items through Shopify's cart API and hands the result to Dawn's own
  cart drawer or cart notification, so the es-* sections keep Dawn's stack.

  window.EsCart.add(items, options) -> Promise<Response JSON>
    items:   [{ id: <variant id>, quantity: <int> }]
    options: { sectionsUrl: string }

  Focus and announcements:
  - Before adding from the page, the clicked control is stored with
    setActiveElement() so closing the drawer returns focus to it.
  - When the add comes from inside an already-open drawer, Dawn's open()
    returns early, so focus is re-trapped here and the add is announced
    through #CartDrawer-LiveRegionText.
*/
(function () {
  'use strict';

  function cartElement() {
    return document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  }

  function routes() {
    var r = window.routes || {};
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return {
      add: r.cart_add_url || root + 'cart/add',
      cart: r.cart_url || root + 'cart'
    };
  }

  function sectionsToRender(cart) {
    if (!cart) return [];
    if (typeof cart.getSectionsToRender === 'function') {
      try {
        return cart.getSectionsToRender().map(function (s) { return s.id; });
      } catch (e) {
        return [];
      }
    }
    return [];
  }

  function drawerIsOpen(cart) {
    return !!(cart && cart.tagName === 'CART-DRAWER' && cart.classList.contains('active'));
  }

  function addedTitle(json) {
    var first = json && (json.items ? json.items[0] : json);
    if (!first) return '';
    return String(first.product_title || first.title || '').replace(/^Elite Sleep\s+/i, '');
  }

  function announce(text) {
    setTimeout(function () {
      var live = document.getElementById('CartDrawer-LiveRegionText');
      if (live) live.textContent = text;
    }, 150);
  }

  function add(items, options) {
    options = options || {};
    var cart = cartElement();
    var sections = sectionsToRender(cart);
    var wasOpen = drawerIsOpen(cart);

    /* Remember where focus was so closing the drawer returns it there. */
    if (cart && !wasOpen && typeof cart.setActiveElement === 'function' &&
        document.activeElement && document.activeElement !== document.body) {
      cart.setActiveElement(document.activeElement);
    }

    /* A single item is posted in the shape Dawn's product form uses, so the
       response carries the line item key that cart-notification expects. */
    var body = items.length === 1
      ? { id: items[0].id, quantity: items[0].quantity }
      : { items: items };
    if (sections.length) {
      body.sections = sections;
      body.sections_url = options.sectionsUrl || window.location.pathname;
    }

    return fetch(routes().add + '.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/javascript',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify(body)
    })
      .then(function (response) {
        return response.json().then(function (json) {
          if (!response.ok || json.status) {
            var err = new Error(json.description || json.message || 'Cart error');
            err.payload = json;
            throw err;
          }
          return json;
        });
      })
      .then(function (json) {
        if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
          window.publish(window.PUB_SUB_EVENTS.cartUpdate, {
            source: 'product-form',
            productVariantId: items[0] && items[0].id,
            cartData: json
          });
        }
        if (cart && typeof cart.renderContents === 'function') {
          if (cart.classList) cart.classList.remove('is-empty');
          cart.renderContents(json);

          if (wasOpen) {
            var box = document.getElementById('CartDrawer');
            if (box && typeof window.trapFocus === 'function') {
              window.trapFocus(box, box.querySelector('.cart-item__name') || box.querySelector('.drawer__inner'));
            }
          }

          if (cart.tagName === 'CART-DRAWER') {
            var qty = items.reduce(function (n, it) { return n + (parseInt(it.quantity, 10) || 0); }, 0);
            var title = addedTitle(json);
            if (title) announce(qty + (qty === 1 ? ' pack of ' : ' packs of ') + title + ' added to your cart');
          }
        } else {
          window.location.href = routes().cart;
        }
        return json;
      });
  }

  window.EsCart = { add: add };
})();